import { sanitizeMarketplaceHtml } from "./utils";

type HtmlContentProps = {
  html: string;
};

/**
 * Renders CMS-driven marketplace copy that may contain inline formatting
 * markup (e.g. `<sup>1</sup>`). Sanitized to an allowlist of inline tags,
 * so it is safe to inject.
 */
export const HtmlContent = ({ html }: HtmlContentProps) => (
  <span dangerouslySetInnerHTML={{ __html: sanitizeMarketplaceHtml(html) }} />
);
